import { useEffect } from 'react'
import TagManager from 'react-gtm-module'
import { Config } from '@chegg-wt/core/config'
import { isDashboardPage } from '@chegg-wt/core/state/app/selectors'
import { getCookie, Cookies } from '../utils/cookies'
import { getSubdomain } from '../utils/gtm'

const DASHBOARD = 'dashboard'
const CORE_CITATION_FLOW = 'core citation flow'
const getPageGroup = () => (isDashboardPage() ? DASHBOARD : CORE_CITATION_FLOW)

const useInitGTM = () => {
  useEffect(() => {
    const dataLayer = {
      release: Config.releaseVersion,
      event: 'dataLayer-loaded',
      subdomain: getSubdomain(document.location.hostname),
      pageGroup: getPageGroup(),
      archieLeagueAdVersion: getCookie(Cookies.AdLayout),
    }
    const tagManagerArgs = {
      gtmId: Config.gtmID,
      auth: Config.gtmAuth,
      preview: Config.gtmPreview,
      dataLayer,
    }
    TagManager.initialize(tagManagerArgs)
  }, [])
}

export default useInitGTM
